import GeneratedInvoice from "../../components/admin/generated-invoice";

const GeneratedInvoicePage = () => {
  return (
    <GeneratedInvoice />
  );
};

export default GeneratedInvoicePage;